import { CSSProperties } from 'react';
import { Button } from '@shared/components/Button';
import { TimeTrackerComponentData } from '@shared/data/entity/fields/TimeTrackerField';
import { API } from '@shared/types/api';
import { useOnStartTimeTracker, useOnStopTimeTracker } from './hooks';

interface Props {
  component: API.TimeTrackerComponent;
  data: TimeTrackerComponentData;
  loading?: boolean;
  isRunning: boolean;
  style?: CSSProperties;
  onDataChanged: (newData: TimeTrackerComponentData) => void;
}

export function TimeTrackerButton({
  component,
  data,
  loading = false,
  isRunning,
  style,
  onDataChanged,
}: Props) {
  const onPressStart = useOnStartTimeTracker(data, onDataChanged);
  const onPressStop = useOnStopTimeTracker(data, onDataChanged);

  return (
    <Button
      label={isRunning ? component.endButtonLabel : component.startButtonLabel}
      variant="secondary"
      danger={isRunning}
      size="medium"
      loading={loading}
      onClick={isRunning ? onPressStop : onPressStart}
      style={style}
    />
  );
}
